// eslint-disable-next-line filenames/match-exported
import CdpClient from '../client';
import config from 'config/config';

const riskCdpClient = new CdpClient(config.customerDataPlatform.riskApiKey);

export default riskCdpClient;
